import React, { useState, useRef } from 'react';
import { handleTouchStart, handleTouchMove, handleTouchEnd } from '../utils/swipeDetection';

const SwipeHandler = ({ children, moveBoard }) => {
  const [touchStart, setTouchStart] = useState(null);
  const touchSurfaceRef = useRef(null);

  return (
    <div
      ref={touchSurfaceRef}
      onTouchStart={(e) => handleTouchStart(e, setTouchStart)}
      onTouchMove={handleTouchMove}
      onTouchEnd={(e) => handleTouchEnd(e, touchStart, setTouchStart, moveBoard)}
      style={{ touchAction: 'none', width: '100%' }}
    >
      {children}
    </div>
  );
};

export default SwipeHandler;